import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import classnames from 'classnames';

import { USER_ROLE_ADMIN, USER_ROLE_PARTNER } from 'common/userRoles';

import SrPartnerPageV2 from 'client/components/SrPartnerPageV2/SrPartnerPageV2';
import SrPartnerPageFooter from 'client/components/SrPartnerPageFooter';

import branch from 'client/core/branch';
import allowedRoles from 'client/helpers/allowedRoles';

@branch({
  currentUser: ['currentUser'],
  currentPartnerUser: ['partners', 'currentPartnerUser'],
  currentPartner: ['partners', 'currentPartner'],
  partnersBySlug: ['partners', 'bySlug'],
})
@allowedRoles({
  roles: [USER_ROLE_ADMIN, USER_ROLE_PARTNER],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
class SrPartnerPage extends Component {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired,
    pageClassName: PropTypes.string,
    navbarLinks: PropTypes.array,
    partnersBySlug: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
  };

  render() {
    const { currentUser, match, partnersBySlug, children, pageClassName, navbarLinks } = this.props;

    const currentPartner = match.params.partnerSlug
      ? partnersBySlug[match.params.partnerSlug]
      : this.props.currentPartner;

    if (!currentPartner) {
      return <Redirect to="/feed" />;
    }

    return (
      <div className={classnames('SrPartnerPage', pageClassName)}>
        <SrPartnerPageV2
          navbarTitle={currentPartner?.displayName}
          navbarImage={currentPartner?.logoUrl}
          navbarImageLink={currentPartner?.slug ? `/partner/${currentPartner.slug}` : null}
          navbarLinks={navbarLinks}
          padding="0"
          contentPadding="0"
          maxWidth="unset"
          navbarMaxWidth="1180px"
          currentUser={currentUser}
          currentPartner={currentPartner}
          redirectToLastLocation={false}
        >
          <div className="SrPartnerPageContent">{children}</div>
          <SrPartnerPageFooter />
        </SrPartnerPageV2>
      </div>
    );
  }
}

SrPartnerPage.displayName = 'SrPartnerPage';

export default SrPartnerPage;
